import DesignTabs from "./DesignTabs";
import SourceTabs from "./SourceTabs";

export const BlockTabs = {
    DesignTabs,
    SourceTabs
}